module.exports = __webpack_public_path__ + "img/selected4-min.7ef08809.png";